import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchDashboardUsers } from '@redux/dashboardUsers/actions';
import {
  selectDashboardUserById,
  selectDashboardUserEditing,
} from '@redux/dashboardUsers/reducers';
import submitOwnOrganisationDashboardUserEdit from '@redux/dashboardUsers/submitOwnOrganisationEdit';
import { usePageActions } from '@hooks';
import { Column, ColumnGroup } from '@cards/Card';
import DashboardUserProfilePictureCard from '@cards/DashboardUsers/ProfilePicture';
import { matchType } from '../../../propTypes';
import DashboardUserWizard from './Wizard';

function EditDashboardUser({ match }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const store = useStore();
  const editing = useSelector(selectDashboardUserEditing);
  const selector = useCallback(selectDashboardUserById(match.params.id), [match]);
  const [loading, dashboardUser] = useSelector(selector);
  const { setTitle } = usePageActions({ title: dashboardUser?.name, showClose: true });

  useEffect(() => {
    if (dashboardUser) {
      setTitle(dashboardUser.name);
    }
  }, [dashboardUser, setTitle]);

  useEffect(() => {
    dispatch(fetchDashboardUsers());
  }, [dispatch]);

  const onSubmit = useCallback(
    values => {
      if (!dashboardUser) return;
      submitOwnOrganisationDashboardUserEdit({
        currentUser: dashboardUser,
        values,
        userId: match.params.id,
        dispatch,
        store,
        t,
      });
    },
    [dashboardUser, dispatch, match.params.id, store, t],
  );

  return (
    <ColumnGroup>
      <Column>
        <DashboardUserWizard
          dashboardUser={dashboardUser}
          isEdit
          loading={loading}
          submitting={editing}
          submitButtonText={t('dashboardUsers:Wizard.button.edit')}
          onSubmit={onSubmit}
        />
      </Column>
      <Column>
        {dashboardUser ? (
          <DashboardUserProfilePictureCard
            organisationSlug={dashboardUser.hospitalId}
            userId={dashboardUser.id}
            displayName={dashboardUser.name}
            initialImageId={dashboardUser.profilePictureImageId}
            initialImageUrl={dashboardUser.profilePictureUrl}
          />
        ) : null}
      </Column>
    </ColumnGroup>
  );
}

EditDashboardUser.propTypes = {
  match: matchType.isRequired,
};

export default EditDashboardUser;
